import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TimeZoneControlPanelController from "./TimeZoneControlPanelController";

const TimeZoneControlPanelComponent = {
    name: "tbTimeZoneControlPanel",
    config: {
        template: TimeZoneControlPanelController.template,
        controller: TimeZoneControlPanelController,
        controllerAs: TimeZoneControlPanelController.controllerAs,
        bindings: {
            additionalPanelClasses: "@tbAdditionalPanelClasses",
            panelIsOpen: "=tbPanelIsOpen",
            panelInitialized: "=tbPanelIsInitialized"
        }
    }
};

const timeZoneControlPanelComponentDependencies = DependencyListBuilder([
    TimeZoneControlPanelController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view.time-zone-control-panel",
        timeZoneControlPanelComponentDependencies
    )
    .component(TimeZoneControlPanelComponent.name, TimeZoneControlPanelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/TimeZoneControlPanel.js
// module id = GI0r
// module chunks = 1